<template>
	<div :class="staticClass" :style="style">
		<div :class="`${staticClass}__bio`">
			<div :class="`${staticClass}__image`">
				<slot></slot>
			</div>
			<div :class="`${staticClass}__name-container`">
				<h2 :class="`${staticClass}__name`">
					{{ name }}
				</h2>
				<h3 :class="`${staticClass}__title`">
					{{ title }}
				</h3>
			</div>
		</div>
		<div v-if="socialItems" :class="`${staticClass}__social`">
			<ul>
				<li
					v-for="(item, index) of socialItems"
					:key="index"
					:class="`${staticClass}__social-item`"
				>
					<span :class="`${staticClass}__social-icon`">
						<svg-icon :icon="item.icon"></svg-icon>
					</span>
					<a :class="`${staticClass}__social-label`" :href="item.url">
						{{ item.label }}
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import SvgIcon from '../SvgIcon/SvgIcon';

export default {
	name: 'UserProfile',
	components: {
		SvgIcon,
	},
	props: {
		color: { type: String, required: false },
		name: { type: String, required: false },
		socialItems: { type: Array, required: false, default: null },
		title: { type: String, required: false },
	},
	computed: {
		style() {
			return this.color ? `--link-color: ${this.color}` : null;
		},
		staticClass() {
			return this.$vnode.data.staticClass || 'user-profile';
		},
	},
};
</script>
